<template>
  <div
    class="inicio"
    :class="transicionActiva ? 'transicion' : ''"
  >
    <div class="fondo">
      <img
        :src="Isologotipo"
        alt="Isologotipo App"
        style="height: 25%; margin: 40px"
      />
      <h2 style="color: #f5fffa; margin: 10px">Hola {{ usuario.Usuario }} - {{ date }}</h2>
    </div>

    <!-- Div para el color de fondo -->
    <el-row
      class="accesos"
      justify="center"
    >
      <el-col
        v-for="acceso in accesos"
        :key="acceso.id"
        :span="getSpan(acceso.roles, usuario)"
      >
        <el-card
          v-if="tieneAcceso(acceso.roles, usuario)"
          class="acceso mi-card"
          shadow="hover"
          @click="redirigir(acceso.ruta)"
        >
          <div class="acceso-icono">
            <!-- agregar un ícono o imagen para cada acceso -->
            <img
              :src="acceso.img"
              :alt="acceso.img"
            />
          </div>
          <div class="acceso-nombre">{{ acceso.nombre }}</div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import Isologotipo from '@/assets/images/isologotipo.png';
import ImgCilindro from '@/assets/images/cilindro.png';
import ImgConfiguracion from '@/assets/images/configuracion.png';
import ImgCotizaciones from '@/assets/images/cotizaciones.png';
import ImgOrdenes from '@/assets/images/ordenes-trabajo.png';
import ImgPropuestas from '@/assets/images/propuestas.png';
import ImgProspectos from '@/assets/images/prospectos.png';
import ImgSolicitudes from '@/assets/images/solicitudes.png';
import ImgSuajes from '@/assets/images/suajes.png';
import ImgClip from '@/assets/images/clip.png';
import ImgReports from '@/assets/images/reports.png';
import ImgUsers from '@/assets/images/user.png';
import getDate from '@/shared/components/utils.js';
import {
  tieneAcceso,
  RolesProspectos,
  RolesSolicitudes,
  RolesCotizaciones,
  RolesPropuestas,
  RolesOrdenesTrabajo,
  RolesCilindros,
  RolesSuajes,
  RolesConfiguracion,
  RolesResource,
  RolesReports,
  RolesEspecificacionesTecnicas,
  RolesUsers,
} from '@/enum/roles_enum.js';
import { useAuthStore } from '@/views/auth/auth_store';
import { useRouter } from 'vue-router';
import { ref } from 'vue';
import {
  ElRow,
  ElCol,
  ElCard,
} from 'element-plus';

const router = useRouter();
const authStore = useAuthStore();
const usuario = authStore.usuario();
const transicionActiva = ref(false);
const date = ref(getDate('dd/mm/yyyy'));

const accesos = [
  {
    id: 1,
    nombre: 'Prospectos',
    ruta: '/page/prospects/list',
    img: ImgProspectos,
    roles: RolesProspectos,
  },
  {
    id: 2,
    nombre: 'Solicitudes',
    ruta: '/page/requests/list',
    img: ImgSolicitudes,
    roles: RolesSolicitudes,
  },
  {
    id: 3,
    nombre: 'Cotizaciones',
    ruta: '/page/prices/list',
    img: ImgCotizaciones,
    roles: RolesCotizaciones,
  },
  {
    id: 4,
    nombre: 'Propuestas',
    ruta: '/page/proposals/list',
    img: ImgPropuestas,
    roles: RolesPropuestas,
  },
  {
    id: 5,
    nombre: 'Especificaciones Técnicas',
    ruta: '/page/technical-specifications/list',
    img: ImgPropuestas,
    roles: RolesEspecificacionesTecnicas,
  },
  {
    id: 6,
    nombre: 'Ordenes de producción',
    ruta: '/page/work-orders/list',
    img: ImgOrdenes,
    roles: RolesOrdenesTrabajo,
  },
  {
    id: 7,
    nombre: 'Recurso',
    ruta: '/page/resource/list',
    img: ImgOrdenes,
    roles: RolesResource,
  },
  {
    id: 8,
    nombre: 'Cilindros',
    ruta: '/page/cylinders/list',
    img: ImgCilindro,
    roles: RolesCilindros,
  },
  {
    id: 9,
    nombre: 'Suajes',
    ruta: '/page/swage/list',
    img: ImgSuajes,
    roles: RolesSuajes,
  },
  {
    id: 10,
    nombre: 'Items',
    ruta: '/page/material/list',
    img: ImgClip,
    roles: RolesConfiguracion,
  },
  {
    id: 11,
    nombre: 'Configuración',
    ruta: '/page/setting/list',
    img: ImgConfiguracion,
    roles: RolesConfiguracion,
  },
  {
    id: 12,
    nombre: 'Reportes',
    ruta: '/page/reports/list',
    img: ImgReports,
    roles: RolesReports,
  },
  {
    id: 13,
    nombre: 'Usuarios',
    ruta: '/page/users/list',
    img: ImgUsers,
    roles: RolesUsers,
  },
];

const redirigir = (ruta) => {
  transicionActiva.value = true;

  setTimeout(() => {
    router.push(ruta);
  }, 1000); // Espera 1 segundos antes de cambiar de ruta
};

const getSpan = (roles, usuario) => {
  if (tieneAcceso(roles, usuario)) {
    return 4;
  } else {
    return 0;
  }
};
</script>

<style scoped>
.inicio {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  height: 100vh;
  overflow: hidden;
}

.accesos {
  margin-top: 10px;
  padding: 0 4% 4% 4%;
  bottom: 5%;
}

.mi-card img {
  width: 10%;
}
.acceso {
  text-align: center;
  cursor: pointer;
  margin-top: 15px;
  margin-right: 10px;
  margin-left: 10px;
  transition: transform 0.3s ease;
  /*width: 100%; Ocupar todo el ancho disponible */
  margin: 4px;
  box-shadow: 0px 2px 6px rgb(0, 0, 0, 0.4);
}

.acceso:hover {
  transform: scale(1.02);
  box-shadow: 0px 2px 6px rgb(0, 0, 0, 0.8);
}

.transicion {
  animation: 1.5s cubic-bezier(0.25, 1, 0.3, 1) polygon-out-opposing-corners both;
}

@keyframes polygon-out-opposing-corners {
  from {
    clip-path: polygon(0 0, 0 100%, 100% 100%, 100% 0);
    background-color: transparent; /* Color de fondo inicial */
  }
  to {
    clip-path: polygon(0 0, 50% 50%, 100% 100%, 50% 50%);
    background-color: #0094d4; /* Color de fondo final */
  }
}

.acceso-nombre {
  margin-top: 10px;
  font-weight: bold;
}
.fondo {
  position: absolute; /* Posición absoluta para cubrir la sección de inicio */
  display: flex;
  align-items: center; /* Alinear verticalmente los elementos */
  top: 0;
  left: 0;
  width: 100%;
  height: 50vh; /* Altura del color de fondo hasta la mitad de la pantalla */
  background-color: #0094d4; /* Color de fondo */
  z-index: -1; /* Colocar detrás de los elementos principales */
  clip-path: polygon(0 0, 100% 0, 100% 65%, 50% 100%, 0 100%); /* Forma personalizada de corte */
}
</style>
